export default __webpack_public_path__ + "static/media/email.4b981194.svg";